import { render, staticRenderFns } from "./AnularBaseModal.vue?vue&type=template&id=ab749fe6"
import script from "./AnularBaseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AnularBaseModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports